<template>
  <amp-carousel class="carousel"
                width="600"
                height="600"
                layout="responsive"
                type="slides"
                loop
                controls
                v-if="slideshow.length">
    <amp-img v-for="(val, key) in slideshow" 
             :src="val.style_600x600"
             :key="key"
             width="600"
             height="600"
             layout="responsive"></amp-img>
  </amp-carousel>
</template>

<script>
  import isEmpty from 'lodash/isEmpty'
  import forEach from 'lodash/forEach'
  import concat from 'lodash/concat'

  export default {
    name: 'article-gallery',
    props: {
      nid: [Number, String],
    },
    computed: {
      node() {
        return this.$store.getters.node(this.nid)
      },
      slideshow() {
        if (isEmpty(this.node.images)) return []
        let images = []
        forEach(this.node.images, (img) => {
          if (img.slideshow) {
            images = concat(images, img)
          }
        })
        return images
      },
    },
  }
</script>

<style lang="scss" scoped>
  .carousel{
    margin-top: rem-calc(16);
    margin-bottom: rem-calc(14);
  }
</style>


// WEBPACK FOOTER //
// AmpCarousel.vue?6a5a7ad6